import React, { useState } from 'react';
import CaremapprModal from '../../../../components/Modal/CaremapprModal/CaremapprModal';
import CareMapprButton from '../../../../components/Button/CareMapprButton';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import type { EndChatExportOptions } from '../../lib/types';
import './endChatConfirmation.scss';

interface EndChatConfirmationProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: (options: EndChatExportOptions) => void | Promise<void>;
  onClose: () => void;
}

const EndChatConfirmation = ({
  show,
  onCancel,
  onConfirm,
  onClose,
}: EndChatConfirmationProps) => {
  const [selectedOptions, setSelectedOptions] = useState<EndChatExportOptions>({
    email: false,
    download: false,
    print: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOptionChange =
    (key: keyof typeof selectedOptions) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSelectedOptions((prevState) => ({
        ...prevState,
        [key]: event.target.checked,
      }));
    };

  const handleConfirm = async () => {
    setIsSubmitting(true);

    try {
      await onConfirm(selectedOptions);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <CaremapprModal
      id="chat-end-modal"
      show={show}
      onHide={onClose}
      bodyClassName="p-0"
      body={
        <div className="chat-end-confirmation d-flex h-100 flex-column justify-content-between p-4">
          <div>
            <div className="d-flex align-items-center gap-3 mb-3">
              <ExclamationTriangleFill size={24} color="#5aaec3" />
              <h2 className="chat-end-confirmation__title mb-0 flex-grow-1">
                You are about to end this chat
              </h2>
              <button
                type="button"
                aria-label="Close end chat modal"
                onClick={onClose}
                className="btn-close chat-modal-close shadow-none"
              />
            </div>
            <p className="chat-end-confirmation__copy mb-0">
              To keep a record of this chat please select from the options
              below:
            </p>
            <div className="d-flex flex-column gap-3 mt-3">
              <label className="chat-end-confirmation__option d-flex align-items-center gap-3 mb-0">
                <input
                  type="checkbox"
                  className="form-check-input mt-0 ms-0 me-0 flex-shrink-0"
                  checked={selectedOptions.email}
                  onChange={handleOptionChange('email')}
                />
                Send to my email
              </label>
              <label className="chat-end-confirmation__option d-flex align-items-center gap-3 mb-0">
                <input
                  type="checkbox"
                  className="form-check-input mt-0 ms-0 me-0 flex-shrink-0"
                  checked={selectedOptions.download}
                  onChange={handleOptionChange('download')}
                />
                Download
              </label>
              <label className="chat-end-confirmation__option d-flex align-items-center gap-3 mb-0">
                <input
                  type="checkbox"
                  className="form-check-input mt-0 ms-0 me-0 flex-shrink-0"
                  checked={selectedOptions.print}
                  onChange={handleOptionChange('print')}
                />
                Print
              </label>
            </div>
          </div>
          <div className="d-flex gap-3 mt-4">
            <CareMapprButton
              type="button"
              variant="secondary"
              label="Cancel & continue chat"
              onClick={onCancel}
              extraClassNames="w-100 my-0"
              disabled={isSubmitting}
            />
            <CareMapprButton
              type="button"
              label="End the chat"
              onClick={() => {
                void handleConfirm();
              }}
              extraClassNames="w-100 my-0"
              isLoading={isSubmitting}
            />
          </div>
        </div>
      }
    />
  );
};

export default EndChatConfirmation;
